import { render, staticRenderFns } from "./OrderHistoryDetails.html?vue&type=template&id=7fbab018&scoped=true&"
import script from "./OrderHistoryDetails.ts?vue&type=script&lang=ts&"
export * from "./OrderHistoryDetails.ts?vue&type=script&lang=ts&"
import style0 from "./OrderHistoryDetails.css?vue&type=style&index=0&id=7fbab018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbab018",
  null
  
)

export default component.exports